











































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { PaginationModel, VHeaders } from '@/models/pagedlistmodel';
import { Base } from '@/components/common/base';
import { IDialogOption } from '@/models/dialog';
import { FileHelper as _file } from '@/helper/file.helper';
import { DateTimeHelper as _dateTime } from '@/helper/date-time.helper';
import { paymentService } from '@/shared';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    Grid: () => import('@/components/common/app.grid.vue'),
    AppDialog: () => import('@/components/common/app.dialog.vue'),
  },
})
export default class CPOChargesListPage extends Base {
  public cpoChargesList: any[] = [];
  public cpoChargesLineItemsList: any[] = [];
  public cpoChargesHeader: VHeaders[] = [];
  public cpoLineItemsHeader: VHeaders[] = [];
  public modelValue: any;

  public chargeList: any = {
    dateInInventory: '',
    id: '',
    make: '',
    model: '',
    modelYear: '',
    stockNumber: '',
    vin: '',
    cpoAmount: '',
    isShowDmsPosting: false,
    cpoTransactionDetails: [],
  };
  public reconcilPostingDate = '';

  public loading: boolean = false;
  public lineItemLoading: boolean = false;

  // Dialog
  public cpoSyncDialog: IDialogOption = {
    width: 400,
    title: 'Post To DMS',
    model: false,
    loading: false,
    action: {
      color: 'success',
      icon: 'fas fa-check',
      text: 'Submit',
      disable: false,
    },
    onAction: (): void => {
      this.postDmsData();
    },
    onClose: (): void => {
      this.onCloseDmsPopup();
    },
  };

  public cpoLineItemsDialog: IDialogOption = {
    width: 800,
    title: 'CPO Line Items ',
    model: false,
    loading: false,
  };

  public actions: any[] = [];
  public pagination = new PaginationModel('DateInInventory', true);
  public lineItemsPagination = new PaginationModel('posteddate', true);

  constructor() {
    super();
  }

  public onCloseDmsPopup() {
    this.modelValue = '';
  }

  public async postDmsData() {
    try {
      this.cpoSyncDialog.action.disable = true;
      var response = await paymentService.vehicleCpoGlPost(
        this.modelValue.stockNumber
      );
      if (response.status) {
        this.modelValue.isShowDmsPosting = false;
        this.showAlert(true, 'Posted Successfully');
        this.setHeaders();
      } else if (!response.status) {
        this.showAlert(false, response.errorMessage);
      }
      this.cpoSyncDialog.action.disable = true;
    } finally {
      this.cpoSyncDialog.action.disable = false;
      this.cpoSyncDialog.model = false;
      this.modelValue = '';
    }
  }

  public setActions() {
    this.actions = [
      {
        type: 'button',
        icon: 'fas fa-dollar-sign',
        title: 'Post To Dms',
        visible: (model: any) => {
          return model.isShowDmsPosting;
        },
        action: (model: any) => {
          this.postCPOToDms(model);
        },
      },
      {
        type: 'button',
        icon: 'fa fa-info',
        title: 'Line Items',
        action: (model: any) => {
          this.lineItems(model);
        },
      },
    ];
  }

  public postCPOToDms(model) {
    this.cpoSyncDialog.model = true;
    this.modelValue = model;
  }

  public lineItems(model) {
    this.cpoLineItemsDialog.model = true;
    this.lineItemLoading = true;
    this.cpoChargesLineItemsList = [];
    if (model.cpoTransactionDetails.length > 0) {
      this.cpoChargesLineItemsList = model.cpoTransactionDetails;
    }
    this.lineItemLoading = false;
  }

  public mounted(): void {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'cpoCharges');

    this.setActions();
    this.setHeaders();
    this.getVehicleCpo();
  }

  public async getVehicleCpoLineItems(): Promise<void> {
    try {
      this.loading = true;
      const result = await paymentService.getVehicleCpo(this.pagination);
      this.cpoChargesLineItemsList = result.results;
      this.lineItemsPagination.totalItems = result.total;
    } finally {
      this.loading = false;
    }
  }

  public setHeaders() {
    this.cpoChargesHeader = [
      {
        text: 'Stock Number',
        align: 'left',
        value: 'stockNumber',
        sortable: false,
      },
      {
        text: 'Inventory Date',
        align: 'left',
        value: 'dateInInventory',
        sortable: true,
        fieldType: 'date',
      },
      {
        text: 'Year',
        align: 'left',
        value: 'modelYear',
        sortable: false,
      },
      {
        text: 'Make',
        align: 'left',
        value: 'make',
        sortable: false,
      },
      {
        text: 'Model',
        align: 'left',
        value: 'model',
        sortable: false,
      },
      {
        text: 'CPO Amount',
        align: 'left',
        value: 'cpoAmount',
        sortable: false,
        fieldType: 'template',
        template: (item) => {
          return `<span>${item.cpoAmount == 0 ? 0 : item.cpoAmount}</span>`;
        },
      },
      {
        align: 'left',
        text: 'Action',
        isNotDataProp: true,
        sortable: false,
      },
    ];

    this.cpoLineItemsHeader = [
      {
        text: 'Posted Date',
        align: 'left',
        value: 'transactionDate',
        sortable: true,
        fieldType: 'date',
      },
      {
        text: 'Account number',
        align: 'left',
        value: 'accountNumber',
        sortable: false,
      },
      {
        text: 'Control Number',
        align: 'left',
        value: 'controlNumber',
        sortable: false,
      },
      {
        text: 'Amount',
        align: 'left',
        value: 'transactionAmount',
        sortable: false,
      },
    ];
  }

  public async getVehicleCpo(): Promise<void> {
    try {
      this.loading = true;
      const result = await paymentService.getVehicleCpo(this.pagination);
      var data = [];
      if (result.results.length > 0) {
        result.results.forEach((x) => {
          if (x.cpoAmount == 0) {
            this.chargeList.isShowDmsPosting = true;
            this.chargeList.dateInInventory = x.dateInInventory;
            this.chargeList.id = x.id;
            this.chargeList.make = x.make;
            this.chargeList.model = x.model;
            this.chargeList.modelYear = x.modelYear;
            this.chargeList.stockNumber = x.stockNumber;
            this.chargeList.vin = x.vin;
            this.chargeList.cpoAmount = x.cpoAmount;
            this.chargeList.cpoTransactionDetails = x.cpoTransactionDetails;
          } else {
            this.chargeList.isShowDmsPosting = false;
            this.chargeList.dateInInventory = x.dateInInventory;
            this.chargeList.id = x.id;
            this.chargeList.make = x.make;
            this.chargeList.model = x.model;
            this.chargeList.modelYear = x.modelYear;
            this.chargeList.stockNumber = x.stockNumber;
            this.chargeList.vin = x.vin;
            this.chargeList.cpoAmount = x.cpoAmount;
            this.chargeList.cpoTransactionDetails = x.cpoTransactionDetails;
          }
          data.push(this.chargeList);
          this.chargeList = {};
        });
      }
      this.cpoChargesList = data;
      this.pagination.totalItems = result.total;
    } finally {
      this.loading = false;
    }
  }

  public updatePaging(paging: any): void {
    this.pagination = paging;
    this.getVehicleCpo();
  }

  public updateLineItemsPaging(paging: any): void {
    this.lineItemsPagination = paging;
  }
}
